import { createReducer, on } from '@ngrx/store';
import * as AuthActions from './auth.actions';
import { AuthState } from '@app/interfaces/auth';

export const initialState: AuthState = {
  token: null,
  loading: false,
  error: null
};

export const authReducer = createReducer(
  initialState,
  on(AuthActions.loadToken, (state) => ({
    ...state,
    loading: true,
    error: null
  })),
  on(AuthActions.loadTokenSuccess, (state, { token }) => ({
    ...state,
    token,
    loading: false,
    error: null
  })),
  on(AuthActions.loadTokenFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(AuthActions.clearToken, (state) => ({
    ...state,
    token: null,
    loading: false,
    error: null
  }))
);